module.exports = __webpack_public_path__ + "assets/img/growup1.562e9788.jpg";